<section class="hero">
    <div class="page-container">
    <div class="hero__overlay">
        <h1 class="title">DATACORE</h1>
        <p class="subtitle">
            {{ 'home.subtitle' | translate }}
        </p>
        <div class="hero__buttons">
            <button [routerLink]="[RouterPath.DEMO, RouterPath.DATA_DOMAINS]">{{ 'home.hero.buttons.exploreDataset' | translate }}<span> →</span></button>
            <button [routerLink]="[RouterPath.SERVICES]">{{ 'home.hero.buttons.exploreServices' | translate }}<span> →</span></button>
            <button>{{ 'home.hero.buttons.talkToSales' | translate }}<span> →</span></button>
        </div>
    </div>
    <video
        #heroVideo
        autoplay
        muted
        loop
        playsinline
        preload="metadata"
        poster="assets/home/earth-video-thumbnail.png"
        class="hero__bg"
    >
        <source src="assets/home/earth-video.mp4" type="video/mp4" />
        {{ 'home.hero.videoFallback' | translate }}
    </video>
    </div>
</section>

<section class="intro">
    <div class="page-container">
    <h2>
        DataCore: <span>
            {{ 'home.intro.highlight1' | translate }}<br />
            {{ 'home.intro.highlight2' | translate }}
        </span>
    </h2>

    <div class="intro__cards">
        <div class="intro__card">
            <div class="icon">
                <img src="assets/home/ideal-icon.png" alt="" />
            </div>
            <h3>{{ 'home.intro.cards.enterprise.title' | translate }}</h3>
            <p>
                {{ 'home.intro.cards.enterprise.description' | translate }}
            </p>
        </div>

        <div class="intro__card">
            <div class="icon">
                <img src="assets/home/Brand-icon.png" alt="" />
            </div>
            <h3>{{ 'home.intro.cards.analytics.title' | translate }}</h3>
            <p>
                {{ 'home.intro.cards.analytics.description' | translate }}
            </p>
        </div>

        <div class="intro__card">
            <div class="icon">
                <img src="assets/home/study-icon.png" alt="" />
            </div>
            <h3>{{ 'home.intro.cards.academic.title' | translate }}</h3>
            <p>
                {{ 'home.intro.cards.academic.description' | translate }}
            </p>
        </div>
    </div>

    <button class="intro__cta" [routerLink]="[RouterPath.GET_DATA, RouterPath.DATA_DOMAINS]">{{ 'home.intro.exploreProducts' | translate }} →</button>
    </div>
</section>

<!-- section: statistics -->
<section class="statistics">
    <div class="page-container">
    <div class="statistics__content">
        <div class="statistics__numbers">
            <div>
                <h2>08</h2>
                <p>{{ 'home.statistics.items.trusted.label1' | translate }} {{ 'home.statistics.items.trusted.label2' | translate }}</p>
            </div>
            <div>
                <h2>10</h2>
                <p>{{ 'home.statistics.items.insights.label1' | translate }} {{ 'home.statistics.items.insights.label2' | translate }}</p>
            </div>
            <div>
                <h2>05</h2>
                <p>{{ 'home.statistics.items.providers.label1' | translate }} {{ 'home.statistics.items.providers.label2' | translate }}</p>
            </div>
        </div>

        <p class="statistics__description">
            <span>{{ 'home.statistics.description.paragraph1' | translate }}</span>
            <span>{{ 'home.statistics.description.paragraph2' | translate }}</span>
        </p>
    </div>
    <div class="statistics__overlay">
        <img src="assets/home/vietnam.png" alt="Map of Vietnam" />
    </div>
    </div>
</section>

<!-- section: features -->
<section class="features">
    <div class="page-container">
    <div class="features__grid">
    <div class="features__item">
        <img
            src="assets/home/image-1.jpg"
            alt="Seamless Data Access"
            class="features__item-img"
        />
        <div class="features__item-content">
            <div class="features__item-header">
                <img
                    src="assets/home/icon-1.png"
                    alt=""
                    class="features__item-icon"
                />
                <h3>{{ 'home.features.seamlessAccess.title' | translate }}</h3>
            </div>
            <p>
                {{ 'home.features.seamlessAccess.description' | translate }}
            </p>
        </div>
    </div>

    <div class="features__item">
        <img
            src="assets/home/image-2.png"
            alt="Powerful Research Tools"
            class="features__item-img"
        />
        <div class="features__item-content">
            <div class="features__item-header">
                <img
                    src="assets/home/icon-2.png"
                    alt=""
                    class="features__item-icon"
                />
                <h3>
                    {{ 'home.features.researchTools.title1' | translate }}
                    {{ 'home.features.researchTools.title2' | translate }}
                </h3>
            </div>
            <p>
                {{ 'home.features.researchTools.description' | translate }}
            </p>
        </div>
    </div>

    <div class="features__item">
        <img
            src="assets/home/image-3.png"
            alt="Business and Industry Solutions"
            class="features__item-img"
        />
        <div class="features__item-content">
            <div class="features__item-header">
                <img
                    src="assets/home/icon-3.png"
                    alt=""
                    class="features__item-icon"
                />
                <h3>
                    {{ 'home.features.businessSolutions.title1' | translate }}
                    {{ 'home.features.businessSolutions.title2' | translate }}
                </h3>
            </div>
            <p>
                {{ 'home.features.businessSolutions.description' | translate }}
            </p>
        </div>
    </div>

    <div class="features__item">
        <img
            src="assets/home/image-4.png"
            alt="Cutting-Edge Analytics"
            class="features__item-img"
        />
        <div class="features__item-content">
            <div class="features__item-header">
                <img
                    src="assets/home/icon-4.png"
                    alt=""
                    class="features__item-icon"
                />
                <h3>{{ 'home.features.analytics.title' | translate }}</h3>
            </div>
            <p>
                {{ 'home.features.analytics.description' | translate }}
            </p>
        </div>
    </div>

    <div class="features__item">
        <img
            src="assets/home/image-5.png"
            alt="Data Reliability and Integrity"
            class="features__item-img"
        />
        <div class="features__item-content">
            <div class="features__item-header">
                <img
                    src="assets/home/icon-5.png"
                    alt=""
                    class="features__item-icon"
                />
                <h3>
                    {{ 'home.features.dataIntegrity.title1' | translate }}
                    {{ 'home.features.dataIntegrity.title2' | translate }}
                </h3>
            </div>
            <p>
                {{ 'home.features.dataIntegrity.description' | translate }}
            </p>
        </div>
    </div>

    <div class="features__item">
        <img
            src="assets/home/image-6.png"
            alt="Academic and Professional Support"
            class="features__item-img"
        />
        <div class="features__item-content">
            <div class="features__item-header">
                <img
                    src="assets/home/study-icon.png"
                    alt=""
                    class="features__item-icon"
                />
                <h3>
                    {{ 'home.features.support.title1' | translate }}
                    {{ 'home.features.support.title2' | translate }}
                </h3>
            </div>
            <p>
                {{ 'home.features.support.description' | translate }}
            </p>
        </div>
    </div>
    </div>
    </div>
</section>

<section class="map-contact">
    <div class="page-container">
    <h2 class="map-contact__title">
        {{ 'home.map.title' | translate }} <br class="map-contact__br"><span>{{ 'home.map.highlight' | translate }}</span>
    </h2>

    <div class="map-contact__layout">
        <!-- map left column -->
        <div class="map-contact__map">
            <div class="map-contact__dropdown">
                <button class="map-contact__dropdown-btn" (click)="toggleDropdown()">
                    {{ 'home.map.dropdown.offices' | translate }}
                    <img src="assets/home/chevron-up.svg" alt="" />
                </button>

                <ul class="map-contact__dropdown-menu" *ngIf="dropdownOpen">
                    <li (click)="selectedOffice = 'hanoi'">{{ 'home.map.dropdown.hanoi' | translate }}</li>
                    <li (click)="selectedOffice = 'hcm'">{{ 'home.map.dropdown.hcm' | translate }}</li>
                </ul>
            </div>

            <iframe
                [src]="offices[selectedOffice] | safeUrl"
                [title]="'home.map.iframeTitle' | translate"
                width="100%"
                height="600"
                style="border: 0"
                allowfullscreen
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
        </div>

        <!-- contact right column -->
        <div class="map-contact__info">
            <div class="map-contact__card">
                <h3>{{ 'home.contact.title' | translate }}</h3>
                <ul>
                    <li>
                        <img
                            src="assets/home/location-icon.png"
                            alt="Location"
                        />
                        <div>
                            <strong>{{ 'home.contact.hn' | translate }}:</strong> {{ 'home.contact.hanoi' | translate }}
                        </div>
                    </li>
                    <li>
                        <img
                            src="assets/home/location-icon.png"
                            alt="Location"
                        />
                        <div>
                            <strong>{{ 'home.contact.hm' | translate }}:</strong> {{ 'home.contact.hcm' | translate }}
                        </div>
                    </li>
                    <li>
                        <img
                            src="assets/home/email-icon.png"
                            alt="Email"
                        />
                        <a href="mailto:contact@datacore.vn"
                            >{{ 'home.contact.email' | translate }}</a
                        >
                    </li>
                    <li>
                        <img
                            src="assets/home/phone-icon.png"
                            alt="Phone"
                        />
                        <span>(+84) 911.900.868</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    </div>
</section>

<!-- Scroll & Chat Buttons -->
<div class="floating-buttons">
    <img
        class="btn-scroll-top"
        *ngIf="showScrollTop"
        (click)="scrollToTop()"
        src="assets/home/top-button.png"
        alt="Scroll to top"
    />
</div>
